export default "__VITE_ASSET__fP3lr$d2__"